const designStyles=document.createElement("style");designStyles.textContent=".rmc-profile-design{min-width:0;margin:0;padding:12px;border:1px solid #ddd;border-radius:8px}\n.rmc-profile-design legend{padding-inline:6px;font-weight:800}\n.rmc-profile-design svg{display:block;margin:0 auto 12px;max-width:100%}\n.rmc-design-presets,.rmc-design-colors{display:grid;gap:8px}\n.rmc-design-presets{grid-template-columns:repeat(2,minmax(0,1fr));margin-bottom:12px}\n.rmc-design-colors{grid-template-columns:repeat(3,minmax(0,1fr))}\n[data-gaming-api] dialog .rmc-design-colors input[type=\"color\"]{padding:4px;cursor:pointer}";document.head.append(designStyles);
const profileStyles=document.createElement("style");profileStyles.textContent="[data-gaming-api] dialog:has(form[data-profile]){box-sizing:border-box;width:min(440px,calc(100% - 32px));max-height:calc(100dvh - 32px);margin:auto;padding:24px;border:0;border-top:4px solid #e1262f;border-radius:12px;background:#fff;color:#171717;overflow:auto;box-shadow:0 16px 60px #0005}\n[data-gaming-api] dialog:has(form[data-profile])::backdrop{background:#0009}\n[data-gaming-api] dialog form[data-profile]{display:grid;gap:16px;margin:12px 0 0}\n[data-gaming-api] dialog form[data-profile] label{display:grid;gap:6px;margin:0;font-weight:600}\n[data-gaming-api] dialog form[data-profile] :is(input,select,button){box-sizing:border-box;width:100%;min-width:0;min-height:44px;margin:0;font-size:16px}\n[data-gaming-api] dialog form[data-profile] :is(input,select){padding:8px 12px;border:1px solid #aaa;border-radius:5px;background:#fff;color:#171717}\n[data-gaming-api] dialog form[data-profile] button[type=submit]{padding:10px 14px;border:0;border-radius:5px;background:#c71d29;color:#fff;font-weight:700}\n[data-gaming-api] dialog > [data-close]{display:block;margin:0 0 12px auto;min-height:44px}\n[data-gaming-api] dialog [data-error]:empty{display:none}";document.head.append(profileStyles);const leaderStyles=document.createElement("style");leaderStyles.textContent=".race-leader-hud:not([hidden]){display:grid;gap:2px;margin-top:8px;padding:6px 8px;border-left:3px solid #e1262f;background:#171717;color:white;text-align:left;max-width:145px}.race-leader-hud span{font-size:10px;font-variant-numeric:tabular-nums}.race-hud .race-leader-hud strong{font:700 12px/1.25 system-ui,sans-serif;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.race-leader-hud [data-faster=\"true\"]{color:#57db78}.game-standings ol{padding-inline-start:2rem}.game-standings li{padding:.45rem;border-bottom:1px solid #ddd}.game-standings li strong{float:right;font-variant-numeric:tabular-nums}";document.head.append(leaderStyles);const panel = document.querySelector('[data-gaming-api]');
const track = panel?.dataset.track || 'uppsala';
const revision = Number(panel?.dataset.revision || 5);
const selected = document.querySelector('[data-fixed-track]')?.dataset.fixedTrack || new URLSearchParams(location.search).get('track') || 'uppsala';
if (panel && selected === track) {
  const find = selector => panel.querySelector(selector);
  const status = find('[role=status]');
  const saveButton = find('[data-save]');
  const dialog = find('dialog');
  const fullscreenExit = document.getElementById('fullscreen-exit');
  const finishButton = track === 'portimao' && fullscreenExit ? document.createElement('button') : null;
  if (finishButton) {
    finishButton.type = 'button';
    finishButton.className = 'portimao-finish';
    fullscreenExit.before(finishButton);
    finishButton.addEventListener('click', () => {
      fullscreenExit.click();
      panel.scrollIntoView({ block: 'start' });
      if (pending.length) save();
    });
  }
  const storageKey = 'rmc:ranked:' + track + ':' + revision;
  let pending = [];
  let attempt;
  let invited = false;
  const country = find('[name=countryCode]');
  if (country) {
    const labels = new Intl.DisplayNames(["en"], { type: 'region' });
    const codes = 'AD AE AF AG AI AL AM AO AQ AR AS AT AU AW AX AZ BA BB BD BE BF BG BH BI BJ BL BM BN BO BQ BR BS BT BV BW BY BZ CA CC CD CF CG CH CI CK CL CM CN CO CR CU CV CW CX CY CZ DE DJ DK DM DO DZ EC EE EG EH ER ES ET FI FJ FK FM FO FR GA GB GD GE GF GG GH GI GL GM GN GP GQ GR GS GT GU GW GY HK HM HN HR HT HU ID IE IL IM IN IO IQ IR IS IT JE JM JO JP KE KG KH KI KM KN KP KR KW KY KZ LA LB LC LI LK LR LS LT LU LV LY MA MC MD ME MF MG MH MK ML MM MN MO MP MQ MR MS MT MU MV MW MX MY MZ NA NC NE NF NG NI NL NO NP NR NU NZ OM PA PE PF PG PH PK PL PM PN PR PS PT PW PY QA RE RO RS RU RW SA SB SC SD SE SG SH SI SJ SK SL SM SN SO SR SS ST SV SX SY SZ TC TD TF TG TH TJ TK TL TM TN TO TR TT TV TW TZ UA UG UM US UY UZ VA VC VE VG VI VN VU WF WS YE YT ZA ZM ZW'.split(' ');
    const options = codes.map(code => new Option(labels.of(code), code));
    options.sort((a, b) => a.text.localeCompare(b.text, "en"));
    country.append(...options);
  }
  try {
    const saved = JSON.parse(sessionStorage.getItem(storageKey) || '[]');
    if (Array.isArray(saved)) pending = saved;
  } catch {
    // The current tab can still play if browser storage is unavailable.
  }
  function persist() {
    sessionStorage.setItem(storageKey, JSON.stringify(pending));
  }
  let pendingWrite=false;
  function flushPending(){if(!pendingWrite)return;pendingWrite=false;try{persist();}catch(error){report(error);}}
  function schedulePendingSave(){if(pendingWrite)return;pendingWrite=true;if(window.requestIdleCallback)window.requestIdleCallback(flushPending,{timeout:500});else requestAnimationFrame(()=>setTimeout(flushPending,0));}
  window.addEventListener('pagehide',flushPending);
  let saving = false;

  async function api(path, data) {
    const headers = data ? { 'Content-Type': 'application/json' } : {};
    const response = await fetch(panel.dataset.gamingApi + '/' + path, {
      method: data ? 'POST' : 'GET',
      headers,
      body: data ? JSON.stringify(data) : undefined
    });
    const body = await response.json().catch(() => ({}));
    if (!response.ok) throw Object.assign(Error(body.error || "Attempt failed (" + response.status + ').'), { status: response.status, body });
    return body;
  }

  function report(error) {
    status.textContent = error.message;
    if (dialog.open) find('[data-error]').textContent = error.message;
  }

  function updateSave() {
    saveButton.disabled = saving || !pending.length;
    if (finishButton) {
      finishButton.disabled = saving;
      finishButton.textContent = pending.length ? (finishButton.classList.contains('profile-invitation') ? "Create a player profile" : "End and save") : "Stop driving";
    }
    saveButton.textContent = pending.length ? "Save laps (" + pending.length + ')' : "Save laps";
  }

  if (!find('[data-times]')) {
    const standings = document.createElement('section');
    standings.className = 'game-standings';
    standings.innerHTML = "<h2>Fastest this week</h2><p data-week></p><ol data-times></ol>";
    panel.append(standings);
  }
  const driverFlag = code => typeof code === 'string' && /^[A-Z]{2}$/.test(code)
    ? String.fromCodePoint(...Array.from(code, letter => 0x1f1e6 + letter.charCodeAt(0) - 65)) + ' '
    : '';
  async function refresh() {
    const data = await api('leaderboard?track=' + encodeURIComponent(track));
    find('[data-week]').textContent = data.week;
    for (const [selector, rows] of [['[data-times]', data.rows], ['[data-laps]', data.mostLaps]]) {
      const list = find(selector);
      if (!list) continue;
      list.replaceChildren(...rows.slice(0, 5).map(row => {
        const item = document.createElement('li');
        const value = row.timeMs == null ? row.laps + (row.laps === 1 ? " lap" : " laps") : (row.timeMs / 1000).toFixed(3) + ' s';
        const name = document.createElement('span');
        name.textContent = driverFlag(row.countryCode) + row.name;
        const score = document.createElement('strong');
        score.textContent = value;
        item.append(name, score);
        return item;
      }));
      if (rows.length === 0) {
        const empty = document.createElement('li');
        empty.className = 'standings-empty';
        empty.textContent = "No laps have been saved this week yet.";
        list.append(empty);
      }
    }
  }



  async function save(allowLogin = true) {
    if (saving || !pending.length) return;
    saving = true;
    updateSave();
    try {
      for (const lap of pending.slice()) {
        await api('results', lap);
        pending.shift();
        persist();
      }
      status.textContent = "Your laps are saved.";
      await refresh();
    } catch (error) {
      if (error.status === 428) {
        editingProfile = false; find("[data-profile] button[type=submit]").textContent = "Save profile and laps";
        if (error.body?.name) find('[name=name]').value = error.body.name;
        if (!dialog.open) dialog.showModal();
      } else if (error.status === 401 && allowLogin && panel.dataset.login) {
        try {
          persist();
          const login = new URL(panel.dataset.login, location.origin);
          const returnUrl = new URL(location.href);
          returnUrl.searchParams.set('resume_laps', '1');
          login.searchParams.set('return_to', returnUrl.pathname + returnUrl.search);
          location.assign(login);
        } catch {
          report(Error("The browser could not keep your laps before sign-in."));
        }
      } else {
        report(error);
      }
    } finally {
      saving = false;
      updateSave();
    }
  }

  function submit(selector, action) {
    find(selector).addEventListener('submit', async event => {
      event.preventDefault();
      const form = event.currentTarget;
      const button = form.querySelector('button[type=submit]');
      button.disabled = true;
      try {
        find('[data-error]').textContent = '';
        await action(Object.fromEntries(new FormData(form)));
      } catch (error) {
        report(error);
      } finally {
        button.disabled = false;
      }
    });
  }

  const recordButton = document.createElement('button');
  recordButton.type = 'button';
  recordButton.hidden = true;
  recordButton.textContent = "Challenge the circuit record";
  saveButton.after(recordButton);
  const recordStatus = document.createElement('p');
  recordStatus.setAttribute('aria-live', 'polite');
  recordButton.after(recordStatus);

  async function loadRecordGhost() {
    const record = await api('record-ghost?track=' + encodeURIComponent(track));
    recordButton.hidden = !record.available;
    if (record.timeMs == null) return;
    const time = (record.timeMs / 1000).toFixed(3);
    recordStatus.textContent = "Circuit record: " + time + ' s · ' + record.name +
      (record.available ? '' : " · No recording for this lap yet.");
    recordButton.onclick = () => {
      window.dispatchEvent(new CustomEvent('rmc:record-ghost', {detail: record}));
      document.getElementById('start-race')?.click();
    };
  }
  loadRecordGhost().catch(() => {});

  let editingProfile = false;
  const defaultDesign = {kartColor: '#ed2735', helmetColor: '#f0f2ec', suitColor: '#252e32'};
  const designKeys = Object.keys(defaultDesign);
  const designPanel = document.createElement('fieldset');
  designPanel.className = 'rmc-profile-design';
  designPanel.innerHTML = `<legend>Your garage</legend>\n    <svg viewBox=\"0 0 160 108\" width=\"160\" height=\"108\" role=\"img\" aria-label=\"Kart and driver preview\">\n      <rect width=\"160\" height=\"108\" rx=\"12\" fill=\"#e9e9e6\"/>\n      <path d=\"M14 26h26v24H14zm106 0h26v24h-26zM12 67h30v27H12zm106 0h30v27h-30z\" fill=\"#22262a\"/>\n      <path d=\"M49 25h62v67H49z\" fill=\"#25282a\"/>\n      <path data-paint=\"kartColor\" d=\"M30 18h100v12H30zm9 27h19v41H39zm63 0h19v41h-19zM38 91h84v9H38zM67 32h26l5 23H62z\"/>\n      <path data-paint=\"suitColor\" d=\"M59 68q21-27 42 0v19H59z\"/>\n      <circle data-paint=\"helmetColor\" cx=\"80\" cy=\"62\" r=\"18\"/>\n      <path d=\"M63 61q17 12 34 0v7q-17 10-34 0z\" fill=\"#161a1d\"/>\n    </svg>\n    <div class=\"rmc-design-presets\" aria-label=\"Colour presets\"></div>`;
  const form = find('[data-profile]');
  form.querySelector('button[type=submit]').before(designPanel);
  const inputs = {};
  const colorRow = document.createElement('div');
  colorRow.className = 'rmc-design-colors';
  for (const [key, title] of [['kartColor','Kart'], ['helmetColor',"Helmet"], ['suitColor','Overall']]) {
    const label = document.createElement('label');
    label.textContent = title;
    const input = document.createElement('input');
    input.type = 'color';
    input.name = key;
    input.value = defaultDesign[key];
    input.addEventListener('input', paintDesign);
    inputs[key] = input;
    label.append(input);
    colorRow.append(label);
  }
  designPanel.append(colorRow);
  function paintDesign() {
    for (const key of designKeys)
      designPanel.querySelector('[data-paint=' + key + ']').setAttribute('fill', inputs[key].value);
  }
  function loadDesign(profile) {
    for (const key of designKeys)
      inputs[key].value = /^#[0-9a-f]{6}$/i.test(profile?.[key]) ? profile[key] : defaultDesign[key];
    paintDesign();
  }
  function applyDesign(profile) {
    const design = Object.fromEntries(designKeys.map(key =>
      [key, /^#[0-9a-f]{6}$/i.test(profile?.[key]) ? profile[key] : defaultDesign[key]]));
    window.RMC_KART_DESIGN = design;
    window.dispatchEvent(new CustomEvent('rmc:kart-design', {detail: design}));
  }
  for (const [name, ...colors] of [
    ['Rotax Classic', ...Object.values(defaultDesign)],
    ['Midnight', '#3046a8', '#efdc4b', '#171a22'],
    ['Neon', '#14b88b', '#ff6896', '#23183b'],
    ['Ice', '#7ed9f3', '#f8fafc', '#22344c']
  ]) {
    const button = document.createElement('button');
    button.type = 'button';
    button.textContent = name;
    button.addEventListener('click', () => loadDesign(Object.fromEntries(designKeys.map((key, index) => [key, colors[index]]))));
    designPanel.querySelector('.rmc-design-presets').append(button);
  }
  paintDesign();

  const editProfile = document.createElement('button');
  editProfile.type = 'button';
  editProfile.textContent = "Edit player profile";
  saveButton.after(editProfile);

  async function openProfile(allowLogin = true) {
    editProfile.disabled = true;
    try {
      const profile = await api('profile');
      find('[name=name]').value = profile.name ?? '';
      if (country) country.value = profile.countryCode ?? '';
      loadDesign(profile);
      find('[data-error]').textContent = '';
      editingProfile = true; find("[data-profile] button[type=submit]").textContent = "Save player profile";
      if (!dialog.open) dialog.showModal();
    } catch (error) {
      if (error.status !== 401 || !allowLogin || !panel.dataset.login) {
        report(error);
        return;
      }
      const login = new URL(panel.dataset.login, location.origin);
      const returnUrl = new URL(location.href);
      returnUrl.searchParams.set('edit_profile', '1');
      login.searchParams.set('return_to', returnUrl.pathname + returnUrl.search);
      location.assign(login.href);
    } finally {
      editProfile.disabled = false;
    }
  }
  editProfile.addEventListener('click', () => openProfile());
  const profileReturn = new URL(location.href);
  if (profileReturn.searchParams.has('edit_profile')) {
    profileReturn.searchParams.delete('edit_profile');
    history.replaceState(history.state, '', profileReturn);
    openProfile(false);
  }

  submit('[data-profile]', async fields => {
    applyDesign(await api('profile', fields));
    dialog.close();
    if (editingProfile) {
      status.textContent = "Player profile updated.";
      await refresh();
    } else {
      await save();
    }
  });
  find('[data-close]').addEventListener('click', () => dialog.close());
  saveButton.addEventListener('click', () => save());
  window.addEventListener('rmc:lap-start', () => {
    attempt = api('attempts', { track, revision }).then(data => data.attempt);
    attempt.catch(error => report(track === 'portimao' && [400, 404].includes(error.status)
      ? Error("Lap saving is not yet available for Portimão.")
      : error));
  });
  window.addEventListener('rmc:valid-lap', event => {
    if (!attempt || !event.detail.proof) return;
    attempt.then(value => {
      pending.push({ attempt: value, proof: event.detail.proof });
      if (!invited && country) {
        invited = true;
        status.textContent = "Save your time to the leaderboard. Sign in and create a player profile with an alias and country, or keep racing.";
        finishButton?.classList.add('profile-invitation');
      }
      updateSave();
      schedulePendingSave();
    }, () => {}).catch(report);
  });
  api('profile').then(applyDesign).catch(() => {});
  panel.hidden = false;
  updateSave();
  refresh().catch(error => report(track === 'portimao' && error.status === 404
    ? Error("The leaderboard is not yet available for Portimão.")
    : error));
  const current = new URL(location.href);
  if (current.searchParams.has('resume_laps')) {
    current.searchParams.delete('resume_laps');
    history.replaceState(history.state, '', current);
    if (pending.length) save(false);
  }
}
